import templateUrl from './employee-audit-log-picker.component.html'

export const EmployeeAuditLogPickerComponent = {
    controller: EmployeeAuditLogPickerController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        auditLogs: "<",
        employeeLimit: "<",
        onSelectAuditLog: "&"
    }
};

function EmployeeAuditLogPickerController() {
    const vm = this;
    vm.auditLogs;
    vm.employeeLimit = 25;
    vm.employeeFilter;
    vm.onSelectAuditLog;
}
